export const EVENT_SALESFORCE_CREATE_IMPORT_CSV = 'salesforce-create-import-csv'
export const EVENT_SALESFORCE_PUBLISH_PRODUCTS = 'salesforce-publish-products'
export const EVENT_SALESFORCE_GET_CONNECTOR = 'salesforce-get-connector'
